import styles from "../../styles";
import "../../styles/index.css";
import React from "react";
import API from "../../api/requests";
import WindowManager from "../WindowManager";
import Desktop from "../Desktop";
import FileSystem from "../FileSystem";
import SystemAPI from "../SystemAPI";
const {
  loadFileSystem,
  syncFileSystem,
  handleInstallApp,
  getSystemData,
  setSystemData,
} = API;

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileSystem: null,
      systemAPI: null,
      systemData: {},
      windowManager: new WindowManager([], () => {}),
      saved: true,
    };
    this.setDataChanged = this.setDataChanged.bind(this);
    this.updateSystemData = this.updateSystemData.bind(this);
  }

  componentDidMount() {
    if (this.props.localMode) {
      const cachedFsData = JSON.parse(window.localStorage.getItem("fsData"));
      const cachedSysData = JSON.parse(window.localStorage.getItem("sysData"));
      const fileSystem = new FileSystem(
        cachedFsData,
        [this.setDataChanged],
        alert.bind(window)
      );
      const systemData = cachedSysData ? cachedSysData : {};
      this.setState((state) => ({
        ...state,
        fileSystem,
        systemData,
        systemAPI: new SystemAPI(fileSystem, systemData, this.updateSystemData),
      }));
    } else {
      loadFileSystem(this)
        .then(() => getSystemData(this))
        .then(() => {
          this.setState((state) => ({
            ...state,
            systemAPI: new SystemAPI(
              state.fileSystem,
              state.systemData,
              this.updateSystemData
            ),
          }));
        });
    }
  }

  setDataChanged() {
    if (this.props.localMode) {
      const fsData = this.state.fileSystem.outputRawData();
      window.localStorage.setItem("fsData", JSON.stringify(fsData));
    } else {
      syncFileSystem(this);
    }
  }

  updateSystemData(data) {
    if (this.props.localMode) {
      this.setState((state) => ({
        ...state,
        systemData: { ...state.systemData, ...data },
      }));
      window.localStorage.setItem(
        "sysData",
        JSON.stringify({ ...this.state.systemData, ...data })
      );
    } else {
      setSystemData(data, this);
    }
  }

  render() {
    return (
      <div
        className="home"
        style={{ ...styles.fullScreenContainer, backgroundColor: "black" }}
      >
        {this.state.fileSystem ? (
          <Desktop
            userId={this.props.userId}
            userInfo={this.props.userInfo}
            localMode={this.props.localMode}
            updateUserInfo={this.props.updateUserInfo}
            fileSystem={this.state.fileSystem}
            systemAPI={this.state.systemAPI}
            windowManager={this.state.windowManager}
            signOutUser={this.props.signOutUser}
            systemData={this.state.systemData}
            updateSystemData={this.updateSystemData}
            handleInstallApp={(data) => handleInstallApp(data, this)}
          />
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default Home;
